<template>
    <div class="input-tag"> 

        <input :class="css" type="text" />

        <div class="input-tag__container" @click="focus">

            <div class="input-tag__container__list"
                :class="css">
                <span class="tag"
                    v-for="tag, index in value"
                    v-bind:key="index"
                    @click.stop>
                    {{tag}}
                    <i class="clear"
                        @click="remove(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path fill="currentcolor" d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg>
                    </i>
                </span>
                <span v-if="allowed" class="input-tag-field" :class="{ 'active': active, 'error': error }">
                    <span class="input-tag-field__text">
                        <span class="input-tag-value" aria-hidden="true">{{ current }}</span>
                        <input type="text"
                            size="1"
                            v-model="current"
                            v-on:keydown.enter.prevent="add"
                            @blur="blur"
                            @click.stop
                            @focus="focus"/>
                    </span>
                    <button class="button"
                        type="button"
                        @click.stop="add">Ajouter</button>
                    <span class="tag tag--new" @click.stop="focus">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32"><path fill="currentcolor" d="M12.63 31.98V18.87H.03v-6.22h12.6V.05h6.2v12.6h13.12v6.22H18.84v13.1z"></path></svg>
                    </span>
                </span>
            </div>

        </div>

    </div>
</template>

<script>
export default {

    props: [ 'value', 'css', 'check', 'max' ],

    data: function() {
        return {
            current: '',
            entried: false,
            error: false,
        }
    },

    computed: {

        active: function() {
            return this.current !== ''
                || this.entried
        },

        allowed: function() {

            if ( this.max && parseInt(this.max) <= this.value.length ) {
                return false
            }

            return true
        }
    },

    methods: {

        add () {
            this.error = false

            if ( this.check ) {
                if ( !this.check(this.current) ) {
                    this.error = true
                    return
                }
            }

            let clonedValue = this.value.slice()
            clonedValue.push(this.current)
            this.current = ''
            this.$emit('input', clonedValue)
        },

        blur () {
            this.entried = false
        },

        focus () {
            if ( !this.allowed ) return
            this.entried = true
            setTimeout(() => this.input.focus(), 100)
        },

        remove (index) {
            let clonedValue = this.value.slice()
            clonedValue.splice(index, 1)
            this.$emit('input', clonedValue)
        },
    },

    mounted () {
        this.input = this.$el.querySelector('.input-tag-field .input-tag-field__text > input')
    },
}
</script>

<style scoped>

/**
 * FIX Mesmerize
 */
*,
*::before,
*::after {
    display: inherit;
    content: none;
    width: auto;
}

.input-tag {
    position: relative;
    display: inline-block;
    position: relative;
    width: 100%;
}

.input-tag > input {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    width: 100% !important;
    height: 100% !important;
}

.input-tag > .input-tag__container {
    display: flex;
    padding: 3px;
}

.input-tag > .input-tag__container > .input-tag__container__list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 3px;
    cursor: text;
}

.input-tag-field {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    height: 2.5rem;
}

.input-tag-field:not(.active) .input-tag-field__text {
    cursor: text;
}

.input-tag-field .input-tag-field__text {
    position: relative;
}

.input-tag-field .input-tag-field__text > input,
.input-tag-field .input-tag-field__text > .input-tag-value {

    display: inline-flex !important;
    height: 100% !important;
    min-width: 10rem;
    padding: 0 6px;

    -webkit-appearance: none !important;
       -moz-appearance: none !important;
            appearance: none !important;

    background: transparent !important;
    border: 0 none !important;
    border-radius: 3px !important;
    box-shadow: none !important;
    color: inherit;
    outline: 0 none !important;

    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
}

.input-tag-field .input-tag-field__text > input {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.input-tag-field > .input-tag-field__text > .input-tag-value {
    visibility: hidden;
    white-space: pre;
}

.input-tag-field.error {
    color: crimson;
}

.input-tag-field.active .input-tag-field__text > input {
    background: rgba(0, 0, 0, 0.1) !important;
}

.input-tag-field > button {
    max-height: 100% !important;
    min-height: 100% !important;
    line-height: 100% !important;
    margin: 0 !important;
    margin-left: 3px !important;
    transition: 0 none !important;
}

.input-tag-field:not(.active) > button {
    opacity: 0;
}

.input-tag-field > .tag.tag--new {
    position: absolute !important;
    top: 0;
    bottom: 0;
    left: 0;
}

.input-tag-field.active > .tag.tag--new  {
    display: none;
}

.tag {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    padding: 0 6px;
    background-color: rgb(13, 197, 193);
    border-radius: 3px;
    color: white;
    cursor: auto;
}

.tag.tag--new {
    width: 2.5rem;
    cursor: pointer;
}

.tag i {
    cursor: pointer;
    margin-left: 12px;
}

</style>
